import { getChatApiBase, getChatApiHeaders } from './chatApiClient'
import axios from './axiosInstance'
import constants from '../constants'

export default function init() {
  console.log('users init')
}

export async function list(
  app,
  apiHost,
  pageNo = 1,
  searchText = '',
  onlyDeactivated = 0,
  filters = {},
) {
  const searchParam = filters.searchKey
    ? encodeURIComponent(filters.searchKey)
    : encodeURIComponent(searchText || '')
  let URL = `${getChatApiBase(app, apiHost)}/users?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchParam}&onlyDeactivated=${onlyDeactivated}&useCursoredIndex=1`

  if (filters.uids && filters.uids.length > 0) {
    URL += `&uids=${filters.uids.map(u => encodeURIComponent(u)).join(',')}`
  }
  if (filters.roles && filters.roles.length > 0) {
    URL += `&role=${filters.roles.map(r => encodeURIComponent(r)).join(',')}`
  }
  if (filters.status && filters.status.length > 0) {
    URL += `&status=${encodeURIComponent(filters.status[0])}`
  }
  if (filters.createdAtFrom) {
    URL += `&createdAt[from]=${encodeURIComponent(filters.createdAtFrom)}`
  }
  if (filters.createdAtTo) {
    URL += `&createdAt[to]=${encodeURIComponent(filters.createdAtTo)}`
  }
  if (filters.updatedAtFrom) {
    URL += `&updatedAt[from]=${encodeURIComponent(filters.updatedAtFrom)}`
  }
  if (filters.updatedAtTo) {
    URL += `&updatedAt[to]=${encodeURIComponent(filters.updatedAtTo)}`
  }
  if (filters.includeSystemUsers) {
    URL += `&includeSystemUsers=true`
  }

  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function get(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function add(post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function search(app, apiHost, searchText, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/users?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function userSearch(id, app, apiHost, searchText, pageNo = 1) {
  const URL = `${getChatApiBase(
    app,
    apiHost,
  )}/users/${id}/friends?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function groupSearch(id, app, apiHost, searchText, pageNo = 1) {
  const URL = `${getChatApiBase(
    app,
    apiHost,
  )}/users/${id}/groups?hasJoined=1&searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function inactiveSearch(app, apiHost, searchText, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/users?searchKey=${searchText}&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&onlyDeactivated=1&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
      params: { _: Date.now() },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function del(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
      data: {
        permanent: true,
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function deactivate(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function update(id, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}`
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function activate(id, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users`
  const post = { uidsToActivate: [id] }
  return axios
    .put(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function authTokenDel(id, uid, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${uid}/auth_tokens/${id}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function authTokenList(id, app, apiHost, pageNo = 1) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/auth_tokens?per_page=${
    constants.perPageInListings
  }&page=${pageNo}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

// export async function groupList(id, app, apiHost, pageNo = 1, searchKey = '') {
//   let URL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
//   URL = `${URL}${apiHost}/${getAppEndpointVersion(app)}/users/${id}/groups?hasJoined=1&per_page=${
//     constants.perPageInListings
//   }&page=${pageNo}&searchKey=${searchKey}`
//   return axios
//     .get(`${URL}`, {
//       headers: {
//         appId: app.id,
//         apiKey: app.accessKey,
//         'Content-Type': 'application/json',
//         Accept: 'application/json',
//       },
//     })
//     .then(res => {
//       return res.data
//     })
//     .catch(error => {
//       return error.response.data
//     })
// }

export async function groupList(id, app, apiHost, pageNo = 1, searchText = '') {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/groups?hasJoined=1&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}

export async function searchGroupList(id, app, apiHost, pageNo = 1, searchKey = '') {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/groups?hasJoined=1&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchKey}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function friendList(id, app, apiHost, pageNo = 1, searchText = '') {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/friends?&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function searchFriendList(id, app, apiHost, pageNo = 1, searchKey = '') {
  const URL = `${getChatApiBase(app, apiHost)}/users/${id}/friends?&per_page=${
    constants.perPageInListings
  }&page=${pageNo}&searchKey=${searchKey}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function authTokenAdd(uid, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${uid}/auth_tokens`
  return axios
    .post(
      `${URL}`,
      { force: true },
      {
        headers: getChatApiHeaders(app),
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}
export async function authTokenSearch(uid, app, apiHost, searchText) {
  const URL = `${getChatApiBase(
    app,
    apiHost,
  )}/users/${uid}/auth_tokens?searchKey=${searchText}&useCursoredIndex=1`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function updateFriends(uid, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${uid}/friends`
  return axios
    .post(`${URL}`, post, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function removeFriends(uid, post, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users/${uid}/friends`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
      data: {
        friends: post,
      },
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function addToGroup(uid, guid, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/groups/${guid}/members`
  return axios
    .post(
      `${URL}`,
      { participants: [uid] },
      {
        headers: getChatApiHeaders(app),
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function kickFromGroup(uid, guid, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/groups/${guid}/members/${uid}`
  return axios
    .delete(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function banFromGroup(uid, guid, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/groups/${guid}/bannedusers/${uid}`
  return axios
    .post(
      `${URL}`,
      {},
      {
        headers: getChatApiHeaders(app),
      },
    )
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function updateScopeInGroup(uid, guid, scope, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/groups/${guid}/members`
  let scopeData = { participants: [uid] }
  if (scope === 'Admin') {
    scopeData = { admins: [uid] }
  } else if (scope === 'Moderator') {
    scopeData = { moderators: [uid] }
  }
  return axios
    .post(`${URL}`, scopeData, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function getMultiple(ids, app, apiHost) {
  const URL = `${getChatApiBase(app, apiHost)}/users?uids=${ids}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error.response.data
    })
}

export async function aiAgentUserList(
  app,
  apiHost,
  pageNo = 1,
  searchText = '',
  onlyDeactivated = 0,
  role = '@agentic',
  perPage = '10',
) {
  const URL = `${getChatApiBase(
    app,
    apiHost,
  )}/users?per_page=${perPage}&page=${pageNo}&searchKey=${searchText}&onlyDeactivated=${onlyDeactivated}&useCursoredIndex=1&role=${role}`
  return axios
    .get(`${URL}`, {
      headers: getChatApiHeaders(app),
    })
    .then(res => {
      return res.data
    })
    .catch(error => {
      return error
    })
}
